﻿import { AdditionalBasketActions } from '/WebPortal/config/layout/themes/project/js/src/art.basket.additional.actions.js';
import { AdditionsSummaryInfos } from '/WebPortal/config/layout/themes/project/js/src/art.basket.save.summary.infos.js';
import { MisStatistic } from '/WebPortal/config/layout/themes/project/js/src/art.account.mis.statistic.js';
import { OpaccArticlePrice } from '/WebPortal/config/layout/themes/project/js/src/opacc.article-price.js';
import { OpaccArticleStock } from '/WebPortal/config/layout/themes/project/js/src/opacc.article-stock.js';
import { ARTAccordion } from './art.accordion.js';
import { ArticleSlider } from './art.class.article.slider.js';
import './art.user-dorpdown.js';
import './techno.navigation.js';
import './components.js';
// import CustomNavigation from './custom.class.navigation.js';
import { ARTSlider } from './art.slider.js';

export class Project {
    constructor() {
        this.additionalBasketActions = new AdditionalBasketActions();
        this.AdditionsSummaryInfos = new AdditionsSummaryInfos();
        this.MisStatistic = new MisStatistic();
        new OpaccArticlePrice();
        new OpaccArticleStock();
        new ARTAccordion();
        new ArticleSlider();
        // new CustomNavigation;
        ARTSlider.initSliders();
        this.contentChangeEventListener();
    }

    contentChangeEventListener() {
        let contentWrapper = document.querySelector('.content');
        if (contentWrapper) {
            contentWrapper.addEventListener('change', (e) => {
                new OpaccArticlePrice();
                new OpaccArticleStock();
            });
        }
    }
}

new Project();
